import { MappingRule } from 'src/entities/import';

const hasValue = (value: number | string | null | undefined): boolean => value !== null && value !== undefined && value !== '';

export const hasImportRuleDetailSettings = (rule: MappingRule): boolean => (
  hasValue(rule.weightFactor)
  || hasValue(rule.volumeFactor)
);
